export default function request(url, opt) {
  const headers = {
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/json'
  };

  const options = { ...opt, headers: headers };

  return new Promise((resolve, reject) => {
    if (!url) reject(new Error('URL parameter required'));
    if (!options) reject(new Error('Options parameter required'));

    fetch(url, options)
      .then(response => {
        if (response.status >= 400) {
          reject(response.message);
        }
        
        response.text()
          .then((text) => {
            return text ? JSON.parse(text) : {}
          })
          .then(response => {
            if (response.status >= 400) {
              reject(response.message);
            } else {
              resolve(response);
            }
          })
      })
      .catch(reject);
  });
}



// WEBPACK FOOTER //
// ./src/services/request.js